(function initSizeOptionKeyboardNav() {
  function activateLabel(label) {
    if (!label || label.getAttribute('aria-disabled') === 'true') return;
    var inputId = label.getAttribute('for');
    var input = inputId ? document.getElementById(inputId) : null;
    if (input && input.disabled) return;
    label.click();
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var label = event.target && event.target.closest
      ? event.target.closest(
          '.product-form__input--block label[tabindex], #FacetFiltersFormMobile ul.list-size label[tabindex], .country_size label[tabindex]'
        )
      : null;
    if (!label) return;
    event.preventDefault();
    activateLabel(label);
  });
})();

(function patchStockistShadowOpen() {
  // Stockist uses attachShadow({mode:"closed"}), which blocks theme a11y from
  // seeing .leaflet-popup. Force open mode for Stockist hosts only.
  if (Element.prototype.__esStockistShadowPatched) return;
  var orig = Element.prototype.attachShadow;
  if (typeof orig !== "function") return;
  Element.prototype.__esStockistShadowPatched = true;
  Element.prototype.attachShadow = function (init) {
    var opts = init ? Object.assign({}, init) : {};
    var name = (this.localName || "").toLowerCase();
    var id = this.id || "";
    var className = typeof this.className === "string" ? this.className : "";
    var isStockist =
      name.indexOf("stockist") !== -1 ||
      id.indexOf("stockist") !== -1 ||
      className.indexOf("stockist") !== -1 ||
      !!(this.closest && this.closest("stockist-store-locator"));
    if (isStockist && opts.mode === "closed") opts.mode = "open";
    return orig.call(this, opts);
  };
})();

(function initCarouselStatusAnnouncer() {
  var announceTimer = null;
  var clearTimer = null;
  var lastMessage = '';
  var lastAnnounceAt = 0;

  window.announceCarouselStatus = function announceCarouselStatus(message) {
    var status = document.getElementById('carousel-status');
    if (!status) return;
    var text = (message || '').toString().replace(/\s+/g, ' ').trim();
    if (!text) return;

    var now = Date.now();
    if (text === lastMessage && now - lastAnnounceAt < 400) return;

    status.textContent = '';
    if (announceTimer) clearTimeout(announceTimer);
    if (clearTimer) clearTimeout(clearTimer);
    announceTimer = setTimeout(function () {
      status.textContent = text;
      lastMessage = text;
      lastAnnounceAt = Date.now();
      clearTimer = setTimeout(function () {
        status.textContent = '';
      }, 1000);
    }, 50);
  };
})();

(function initFilterStatusAnnouncer() {
  var announceTimer = null;
  var pendingFromApply = false;

  window.announceFilterStatus = function announceFilterStatus(customMessage) {
    var status = document.getElementById('filter-status');
    var countEl = document.getElementById('ProductCount');

    // Keep ProductCount as a live region even after AJAX innerHTML swaps.
    if (countEl) {
      countEl.setAttribute('role', 'status');
      countEl.setAttribute('aria-live', 'polite');
      countEl.setAttribute('aria-atomic', 'true');
    }

    var filterToggle = document.getElementById('Facets-Toggle');
    if (filterToggle && countEl && !filterToggle.getAttribute('aria-describedby')) {
      filterToggle.setAttribute('aria-describedby', 'ProductCount');
    }

    if (!status) return;

    var countText = countEl ? countEl.textContent.replace(/\s+/g, ' ').trim() : '';
    if (!countText) {
      var productCount = document.querySelectorAll(
        '#ProductGridContainer .product-card, #product-grid .product-card, #ProductGridContainer .grid__item'
      ).length;
      countText =
        productCount === 1 ? '1 product found' : productCount + ' products found';
    }

    // Prefer a short action status; ProductCount live region announces the count itself.
    var message = customMessage || 'Filters applied. ' + countText + '.';

    status.textContent = '';
    if (announceTimer) clearTimeout(announceTimer);
    announceTimer = setTimeout(function () {
      status.textContent = message;
      pendingFromApply = false;
    }, 100);
  };

  function onApplyClick() {
    pendingFromApply = true;
    // Fallback if renderProductCount does not fire (cached/error paths).
    setTimeout(function () {
      if (pendingFromApply) window.announceFilterStatus();
    }, 1200);
  }

  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target && event.target.closest && event.target.closest('.mobile-filters-apply');
      if (btn) onApplyClick();
    },
    true
  );
})();

(function initProductStatusAnnouncer() {
  var announceTimer = null;
  var lastMessage = '';

  window.announceProductStatus = function announceProductStatus(message) {
    var status = document.getElementById('product-status');
    if (!status) return;
    var text = (message || '').toString().replace(/\s+/g, ' ').trim();
    if (!text || text === lastMessage) return;

    status.textContent = '';
    if (announceTimer) clearTimeout(announceTimer);
    announceTimer = setTimeout(function () {
      status.textContent = text;
      lastMessage = text;
    }, 100);
  };
})();

(function initWishlistStatusAnnouncer() {
  var announceTimer = null;
  var clearTimer = null;
  var lastMessage = '';
  var lastAnnounceAt = 0;

  window.announceWishlistStatus = function announceWishlistStatus(message) {
    var status = document.getElementById('wishlist-status');
    if (!status) return;
    var text = (message || '').toString().replace(/\s+/g, ' ').trim();
    if (!text) return;

    // Dedupe identical announcements within 1.5s (click + count observer).
    var now = Date.now();
    if (text === lastMessage && now - lastAnnounceAt < 1500) return;

    status.textContent = '';
    if (announceTimer) clearTimeout(announceTimer);
    if (clearTimer) clearTimeout(clearTimer);
    announceTimer = setTimeout(function () {
      status.textContent = text;
      lastMessage = text;
      lastAnnounceAt = Date.now();
      clearTimer = setTimeout(function () {
        status.textContent = '';
      }, 1000);
    }, 100);
  };

  function isWishlistAdded(btn) {
    return btn.classList.contains('st-is-added');
  }

  function syncWishlistButtonA11y(btn, isAdded) {
    if (!btn) return;
    var addedLabel = btn.getAttribute('data-label-added') || 'Added to Wishlist';
    var addLabel = btn.getAttribute('data-label') || 'Add to Wishlist';
    btn.setAttribute('aria-label', isAdded ? addedLabel : addLabel);
    btn.setAttribute('aria-pressed', isAdded ? 'true' : 'false');
  }

  function showWishlistAddedPopup() {
    // Desktop toast next to the header wishlist heart (hidden on mobile via CSS).
    if (window.innerWidth <= 768) return;
    var host =
      document.querySelector('.thb-secondary-area [data-tb="#wishlist"]') ||
      document.querySelector('[data-tb="#wishlist"]');
    if (!host) return;

    var existing = host.querySelector('.wishlist-message');
    if (existing) existing.remove();

    var messageSpan = document.createElement('span');
    messageSpan.className = 'wishlist-message';
    messageSpan.setAttribute('aria-hidden', 'true');
    messageSpan.textContent = 'Item added to wishlist';
    host.appendChild(messageSpan);
    setTimeout(function () {
      if (messageSpan.parentNode) messageSpan.remove();
    }, 5000);
  }

  function announceWishlistButtonChange(btn, wasAdded) {
    var isAdded = isWishlistAdded(btn);
    if (isAdded === wasAdded) return;

    // Match visible toast wording so SR users hear the same confirmation.
    if (isAdded) {
      window.announceWishlistStatus('Item added to wishlist');
      showWishlistAddedPopup();
    } else {
      window.announceWishlistStatus('Removed from Wishlist');
    }
    syncWishlistButtonA11y(btn, isAdded);

    var handle = btn.getAttribute('data-handle') || btn.getAttribute('data-product-handle');
    if (!handle) return;
    document
      .querySelectorAll(
        '.st-wishlist-button[data-handle="' +
          handle +
          '"], .st-wishlist-button[data-product-handle="' +
          handle +
          '"]'
      )
      .forEach(function (other) {
        syncWishlistButtonA11y(other, isWishlistAdded(other));
      });
  }

  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target && event.target.closest && event.target.closest('.st-wishlist-button');
      if (!btn) return;

      var wasAdded = isWishlistAdded(btn);
      var settled = false;

      var observer = new MutationObserver(function () {
        if (isWishlistAdded(btn) === wasAdded) return;
        settled = true;
        observer.disconnect();
        announceWishlistButtonChange(btn, wasAdded);
      });
      observer.observe(btn, { attributes: true, attributeFilter: ['class'] });

      // Fallback if class never flips (or flips before observer attaches).
      setTimeout(function () {
        observer.disconnect();
        if (!settled) announceWishlistButtonChange(btn, wasAdded);
      }, 800);
    },
    true
  );
})();

function toggleWishlistButton() {
  document.querySelectorAll(".st-wishlist-button").forEach(hiddenBtn => {
    hiddenBtn.addEventListener("click", function() {
      if (this.classList.contains("st-is-added")) return;
      const parentCard = this.closest(".product-card, .product-images--thumbnails,.product-grid-container,.sliderImg-with-Text");
      if (!parentCard) return;      
      const visibleWishlistBtn = parentCard.querySelector(".mobile_message");
      if (visibleWishlistBtn) {
        setTimeout(() => {
          visibleWishlistBtn.classList.remove("m-none");
        }, 500);
        setTimeout(() => {
          visibleWishlistBtn.classList.add("m-none");
        }, 2000);
      }
    });
  });
}
toggleWishlistButton();
  
$(document).ready(function () {
  // country flag with number
  var countryFlag = localStorage.getItem("selectedCountry23")?.toLowerCase();
  var selectedCountrynumber = $(".selected-country #country-flag option[data-code='"+countryFlag+"']").val();

  function setPhoneLimitsByCountryCode(code) {
    const option = $(`.country-flag option[value="${code}"]`);
    if (option.length) {
      const maxDigit = option.attr('max-digit');
      const minDigit = option.attr('min-digit');
      $('.checkout_shipping_address_phone').attr('maxlength', maxDigit).attr('minlength', minDigit);
    }
  }  
  if (countryFlag) {
    $('.country-flag-box .country-flag').css( 'background-image', `url('https://hatscripts.github.io/circle-flags/flags/${countryFlag}.svg')`);
    $('.country-flag-box .country-flag').addClass(countryFlag).removeClass('al');
    $('.selected_country-code').text(selectedCountrynumber);
    
    setPhoneLimitsByCountryCode(selectedCountrynumber);
    $('#country-flag').val(selectedCountrynumber);
  }
  
  $(document).on('change', '.country-flag', function() {
    var $this = $(this);
    var select_op = $this.find('option:selected');
    select_op_val = select_op.data('code');
    var select_val = select_op.val();  
    var $selector = $this.parents('.phone-group').find('.country-flag-box .country-flag');
    
    $selector.attr('class', 'country-flag');
    $this.find('option').removeClass('active');
    select_op.addClass('active');
    
    if (select_op_val) {
      $selector.addClass(select_op_val);
      $('.selected_country-code').text(select_val);
      $selector.css('background-image', `url('https://hatscripts.github.io/circle-flags/flags/${select_op_val}.svg')`);
      setPhoneLimitsByCountryCode(select_val);
    }
  });

  // $("body").on("click", ".size-dropdown-list li", function() {
  //   let variantImage = $(this).data("link");
  //   let variant_id = $("select[data-link-target='"+variantImage+"'] option[data-title='"+$(this).data("variant-title")+"']").val();
  //   let currentVariant = $(this).data("current-variant");
  //   // $(this).parents(".main_item").css({"opacity":"0.7","pointer-events":"none"});
  // let $mainItem = $(this).closest(".main_item");
  // $mainItem.css({ opacity: "0.7", pointerEvents: "none" });
  //   $.ajax({
  //     url:"/cart/add?id="+variant_id,
  //     success:function(data) {
  //       $.ajax({
  //          type: 'POST',
  //            url:"/cart/update",
  //            data:{
  //             updates:{
  //                [currentVariant]:0
  //             }
  //           },
  //           dataType: 'json',
  //          async:false
  //        });
  //        $.ajax({
  //           url:"/cart?section_id=cart-items-ajax",
  //           success: function(data){
  //             $("#cart__form__items").html($(data).find("#cart__form_items").html());
  //             $(".cart__form__items2").html($(data).find("#cart_drawer_items").html());
  //             $("#wishlist_drawer").html($(data).find("#wishlist_drawer_items").html());
  //             $(".mini_cart").html($(data).find(".mini_cart").html())
  //           }
  //        })
  //        $mainItem.removeAttr("style")
  //     },
  //     error: function(data) {
  //       console.log("aaaa",data,data.statusText);
  //     }
  //   })
  // });

  $("body").on('click', function(e) {
    if (!$(e.target).closest('.size-dropdown-list, .size-dropdown-btn').length) {
      $('.size-dropdown-list').removeClass('_active');
       $('.size-dropdown-btn .select-arrow').removeClass('rotate');
    }
  });

  $("body").on("click", ".size-dropdown-list li", function() {
    let variantImage = $(this).data("link");
    let currentcartItem = $(this).closest(".product-cart-item")[0].id;
    console.log("ProductItem",currentcartItem)
    let variant_id = $("select[data-link-target='"+variantImage+"'] option[data-title='"+$(this).data("variant-title")+"']").val();
    let currentVariant = $(this).data("current-variant");
    // $(this).parents(".main_item").css({"opacity":"0.7","pointer-events":"none"});
    let $mainItem = $(this).closest(".main_item");

    $mainItem.css({ opacity: "0.7", pointerEvents: "none" });
    $.ajax({
      url:"/cart/add?id="+variant_id,
      success:function(data) {
        $.ajax({
           type: 'POST',
             url:"/cart/update",
             data:{
              updates:{
                 [currentVariant]:0
              }
            },
            dataType: 'json',
           async:false
         });
         $.ajax({
            url:"/cart?section_id=cart-items-ajax",
            success: function(data){
       
               $("#cart__form__items").html($(data).find("#cart__form_items").html());
              //  $(".cart__form__items2").html($(data).find("#cart_drawer_items").html());
               $(`.cart__form__items2 ${currentcartItem}`).html($(data).find(`#cart_drawer_items  ${currentcartItem}`).html());
              $("#wishlist_drawer").html($(data).find("#wishlist_drawer_items").html());
              $(".mini_cart").html($(data).find(".mini_cart").html())
            }
         })
           $mainItem.removeAttr("style")
      },
      error: function(data) {
     
            $mainItem.removeAttr("style");
      }
    })
  });

  // $("body").on("click", ".size-dropdown-list li", function() {
  //   const $this = $(this);
  //   const variantImage = $this.data("link");
  //   const variantTitle = $this.data("variant-title");
  //   const currentVariant = $this.data("current-variant");
  //   const $mainItem = $this.closest(".main_item");
  //   const variant_id = $(`select[data-link-target='${variantImage}'] option[data-title='${variantTitle}']`).val();
  //   if (!variant_id) {
  //     console.warn("Variant ID not found for:", variantTitle);
  //     return;
  //   }
  //   $mainItem.css({ opacity: "0.6", pointerEvents: "none" });

  //   // Add new variant to cart
  //   // $.ajax({
  //   //   url: `/cart/add?id=${variant_id}`,
  //   //   method: "POST",
  //   //   dataType: "json",
  //   //   success: function() {
  //   //     // Remove old variant from cart
  //   //     $.ajax({
  //   //       type: "POST",
  //   //       url: "/cart/update",
  //   //       data: {
  //   //         updates: {
  //   //           [currentVariant]: 0
  //   //         }
  //   //       },
  //   //       dataType: "json"
  //   //     }).always(function() {
  //   //       // Refresh cart sections
  //   //       $.ajax({
  //   //         url: "/cart?section_id=cart-items-ajax",
  //   //         success: function(data) {
  //   //           $("#cart__form__items").html($(data).find("#cart__form_items").html());
  //   //           $(".cart__form__items2").html($(data).find("#cart_drawer_items").html());
  //   //           $("#wishlist_drawer").html($(data).find("#wishlist_drawer_items").html());
  //   //           $(".mini_cart").html($(data).find(".mini_cart").html());
  //   //         },
  //   //         complete: function() {
  //   //           $mainItem.css({ opacity: "", pointerEvents: "" }); // re-enable
  //   //         }
  //   //       });
  //   //     });
  //   //   },
  //   //   error: function(xhr, status, error) {
  //   //     console.error("Cart add failed:", status, error, xhr.responseText);
  //   //     $mainItem.css({ opacity: "", pointerEvents: "" }); // ensure re-enable
  //   //   }
  //   // });
  //     $mainItem.css({ opacity: "", pointerEvents: "" });
  // });

  // $("body").on("click", ".remove-product", function(e) {
  //   e.preventDefault();
  //   let _this = $(this);
  //   $.ajax({
  //     url:$(this).attr("href"),
  //     success:function() {
  //       _this.parents(".main_item").slideUp(500, function() {
  //         _this.parents(".main_item").remove();
  //         $.ajax({
  //           url:"/cart?section_id=cart-items-ajax",
  //           success: function(data) {
  //             $("#cart__form__items").html($(data).find("#cart__form_items").html());
  //             $("#cart__form__items2").html($(data).find("#cart_drawer_items").html());
  //             $(".mini_cart").html($(data).find(".mini_cart").html())
  //             // if($(".cart__form_items > li").length == 0) {
  //             //   location.href= "/cart"
  //             // }
  //           }
  //         })
  //       })
  //     }
  //   })
  // })

  $("body").on("click", ".add-to-cart-from-cart", function(e) {
    e.preventDefault();
    let _this = $(this);
    _this.css({"opacity": "0.7","pointer-events": "none"});
    let variant_id = _this.parents(".product-cart-item").find("li[data-info].selected").data("vaiant-id");
    $(this).closest('.product-cart-item').addClass('thb-loading');
 const CartDrawer = document.querySelector('cart-drawer');
// 


    fetch("/cart/add?id=" + variant_id, {
      method: 'GET'
    }).then(res => {
   


// Make sure it exists


      return res.text();
    })
    
    .then(myContent => {
      $.ajax({
        url: "/cart?section_id=cart-items-drawer-ajax",
        success: function(data) {
          $("#cart_drawer_inner").html($(data).find("#cart__form_items").html());
          $(".thb-item-count").html($(data).find("#cart__form_items_counter").html());
          $(".cart_drawer_tab .thb-item-count").html("(" + $(data).find("#cart__form_items_counter").html() + ")");
          $("#footer-cart").html($(data).find("#footer_item").html());
          $('.product-cart-item').removeClass('thb-loading');
        }
      });
      
$('.product-cart-item').removeClass('thb-loading');
      _this.parent().find("button").click();
    })
    
    .catch(error => {
      console.log(error);
    });
  });
});


// cart js

$(document).ready(function () {
  // Populate form fields from localStorage
  $("#checkout_shipping_address_first_name").val(localStorage.getItem("firstname") || "");
  $("#checkout_shipping_address_last_name").val(localStorage.getItem("lastname") || "");
  $("#checkout_email_or_phone").val(localStorage.getItem("email") || "");
  $("#checkout_shipping_address_phone").val(localStorage.getItem("phone") || "");

  $("#checkout_shipping_address_address1").val(localStorage.getItem("shipping_address1") || "");
  $("#checkout_shipping_address_address2").val(localStorage.getItem("shipping_address2") || "");
  $("#checkout_shipping_address_city").val(localStorage.getItem("shipping_city") || "");
  $("#checkout_shipping_address_state").val(localStorage.getItem("shipping_state") || "");
  $("#checkout_shipping_address_postcode").val(localStorage.getItem("shipping_code") || "");
  const shippingcountry = localStorage.getItem("shipping_country") || "";
  if (shippingcountry) {
    $("select.checkout_shipping_address_country option").each(function() {
      if ($(this).text().trim() === shippingcountry) {
        $(this).prop('selected', true);
        return false;
      }
    });
  }
  
  $("#checkout_billing_address_address1").val(localStorage.getItem("billing_address1") || "");
  $("#checkout_billing_address_address2").val(localStorage.getItem("billing_address2") || "");
  $("#checkout_billing_address_city").val(localStorage.getItem("billing_city") || "");
  $("#checkout_billing_address_state").val(localStorage.getItem("billing_state") || "");
  $("#checkout_billing_address_postcode").val(localStorage.getItem("billing_code") || "");
  
  const billingcountry = localStorage.getItem("billing_country") || "";
  if (billingcountry) {
    $("select.checkout_billing_address_country option").each(function() {
      if ($(this).text().trim() === billingcountry) {
        $(this).prop('selected', true);
        return false;
      }
    });
  }
 
  const storedCountryValue = localStorage.getItem("country") || "";
  const $countrySelect = $("select.country-flag");
  $countrySelect.val(storedCountryValue);
  const $selectedOption = $countrySelect.find(`option[value="${storedCountryValue}"]`);

  if ($selectedOption.length) {
    const countryCode = $selectedOption.val(); // e.g., "+213"
    const countryCodeAlpha2 = $selectedOption.data("code"); // e.g., "dz"
    const minDigit = $selectedOption.attr("min-digit");
    const maxDigit = $selectedOption.attr("max-digit");
    $("#checkout_shipping_address_phone").attr("minlength", minDigit).attr("maxlength", maxDigit);
    $(".country-flag-box .country-flag").css("background-image", `url('https://hatscripts.github.io/circle-flags/flags/${countryCodeAlpha2}.svg')`).attr("class", `country-flag ${countryCodeAlpha2}`);
    $(".selected_country-code").text(countryCode);
  }
});
  

(function initCollectionDropdownFocusTrap() {
  function getMenu(container) {
    return container.querySelector('.dropdown-content');
  }

  function getFocusable(menu) {
    if (!menu) return [];
    return Array.from(menu.querySelectorAll('a[href], button:not([disabled])'));
  }

  function setExpanded(container, isOpen) {
    const trigger = container.querySelector('.dropbtn');
    const menu = getMenu(container);
    trigger?.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    if (!menu) return;
    if (isOpen) {
      menu.removeAttribute('inert');
      menu.setAttribute('aria-hidden', 'false');
      menu.hidden = false;
    } else {
      menu.setAttribute('inert', '');
      menu.setAttribute('aria-hidden', 'true');
    }
  }

  function focusFirstItem(container) {
    const menu = getMenu(container);
    if (!menu) return;
    menu.removeAttribute('inert');
    menu.setAttribute('aria-hidden', 'false');
    menu.hidden = false;
    // Force layout so the browser treats items as focusable.
    void container.offsetHeight;

    const first =
      menu.querySelector('a.dropmenuoption[href], .dropdown-list-wrapper a[href], a[href]') ||
      menu;

    const moveFocus = function () {
      if (!container.classList.contains('active')) return;
      if (document.activeElement && document.activeElement.classList.contains('dropbtn')) {
        document.activeElement.blur();
      }
      first.focus({ preventScroll: true });
    };

    moveFocus();
    setTimeout(moveFocus, 0);
    setTimeout(moveFocus, 100);
    setTimeout(moveFocus, 200);
  }

  function openMenu(container, trigger) {
    document.querySelectorAll('.dropdown-collection.active').forEach(function (dropdown) {
      if (dropdown !== container) {
        dropdown.classList.remove('active');
        setExpanded(dropdown, false);
      }
    });
    container.classList.add('active');
    container._trigger = trigger;
    setExpanded(container, true);
    focusFirstItem(container);
  }

  function closeMenu(container, restoreFocus) {
    container.classList.remove('active');
    setExpanded(container, false);
    if (restoreFocus) {
      (container._trigger || container.querySelector('.dropbtn'))?.focus();
    }
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('.dropdown-collection .dropbtn');
    if (!button) return;
    const container = button.closest('.dropdown-collection');
    if (!container) return;
    setTimeout(function () {
      document.querySelectorAll('.dropdown-collection').forEach(function (dropdown) {
        setExpanded(dropdown, dropdown.classList.contains('active'));
      });
      if (container.classList.contains('active')) {
        container._trigger = button;
        focusFirstItem(container);
      }
    }, 100);
  });

  document.addEventListener('keydown', function (event) {
    const button = event.target.closest ? event.target.closest('.dropdown-collection .dropbtn') : null;
    const containerFromButton = button && button.closest('.dropdown-collection');
    const openContainer = document.querySelector('.dropdown-collection.active');

    if (
      containerFromButton &&
      !event.shiftKey &&
      (event.key === 'Tab' || event.key === 'Enter' || event.key === ' ' || event.key === 'ArrowDown')
    ) {
      event.preventDefault();
      openMenu(containerFromButton, button);
      return;
    }

    if (!openContainer) return;
    const menu = getMenu(openContainer);

    if (event.key === 'Escape') {
      event.preventDefault();
      closeMenu(openContainer, true);
      return;
    }

    if (event.key !== 'Tab' || !menu) return;

    const items = getFocusable(menu);
    if (!items.length) {
      event.preventDefault();
      menu.focus();
      return;
    }

    const first = items[0];
    const last = items[items.length - 1];
    const active = document.activeElement;

    if (event.shiftKey) {
      if (active === first || !menu.contains(active)) {
        event.preventDefault();
        last.focus();
      }
    } else if (active === last || !menu.contains(active)) {
      event.preventDefault();
      first.focus();
    }
  }, true);
})();

(function initCollectionMenuSkip() {
  const skip = document.getElementById('SkipToCollectionMenu');
  if (skip) {
    skip.addEventListener('click', function (event) {
      event.preventDefault();
      const root = document.getElementById('CollectionMenuList') || document.getElementById('custom-menu');
      const button = root && root.querySelector('.dropbtn');
      (button || root)?.focus();
    });
  }

  function syncMobileDrawerInert() {
    document.querySelectorAll('.mobile-menu-drawer').forEach(function (drawer) {
      const open = drawer.closest('.mobile-toggle-wrapper')?.classList.contains('active');
      if (open) drawer.removeAttribute('inert');
      else drawer.setAttribute('inert', '');
    });
  }
  syncMobileDrawerInert();
  document.querySelectorAll('.mobile-toggle-wrapper').forEach(function (wrapper) {
    new MutationObserver(syncMobileDrawerInert).observe(wrapper, { attributes: true, attributeFilter: ['class'] });
  });
})();

(function initLeafletPopupInert() {
  // Stockist maps live under (now-open) shadow roots. Prefer shadow queries;
  // fall back to composedPath for older sessions.
  var inerted = [];
  var lastTrigger = null;
  var observedPopups = new WeakSet();
  var currentPopup = null;
  var lastShadowRoot = null;
  var shadowObserver = null;
  var watchTimer = null;
  var hostObservers = [];

  var POPUP_SELECTOR = '.leaflet-popup, .gm-style-iw-c, .gm-style-iw';

  function isMapPopupNode(node) {
    return !!(
      node &&
      node.classList &&
      (node.classList.contains('leaflet-popup') ||
        node.classList.contains('gm-style-iw-c') ||
        node.classList.contains('gm-style-iw'))
    );
  }

  function getFocusable(container) {
    if (!container) return [];
    return Array.from(
      container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (el) {
      if (el.hasAttribute('disabled') || el.getAttribute('aria-hidden') === 'true') return false;
      return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    });
  }

  function clearBackgroundInert() {
    inerted.forEach(function (el) {
      el.removeAttribute('inert');
    });
    inerted = [];
  }

  function isVisiblePopup(popup) {
    if (!popup || !popup.isConnected) return false;
    // Leaflet popups often have offsetParent === null due to transforms.
    var style = window.getComputedStyle(popup);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
    return !!(popup.offsetWidth || popup.offsetHeight || popup.getClientRects().length);
  }

  function collectStockistShadowRoots() {
    var roots = [];
    document.querySelectorAll('stockist-store-locator').forEach(function (host) {
      if (host.shadowRoot) roots.push(host.shadowRoot);
      Array.prototype.forEach.call(host.querySelectorAll('*'), function (el) {
        if (el.shadowRoot) roots.push(el.shadowRoot);
      });
    });
    return roots;
  }

  function findPopupInPath(event) {
    var path = typeof event.composedPath === 'function' ? event.composedPath() : [];
    var i;
    for (i = 0; i < path.length; i++) {
      if (isMapPopupNode(path[i])) return path[i];
    }
    for (i = 0; i < path.length; i++) {
      var n = path[i];
      if (!n || typeof n.getRootNode !== 'function') continue;
      var root = n.getRootNode();
      if (!root || typeof root.querySelector !== 'function') continue;
      if (root === document || root === document.documentElement) continue;
      var found = root.querySelector(POPUP_SELECTOR);
      if (isVisiblePopup(found)) return found;
    }
    return null;
  }

  function getActiveElement(popup) {
    if (!popup) return document.activeElement;
    var root = popup.getRootNode && popup.getRootNode();
    if (root && root.activeElement) return root.activeElement;
    return document.activeElement;
  }

  function setBackgroundInert(dialog) {
    clearBackgroundInert();
    var node = dialog;
    while (node && node !== document.body) {
      var parent = node.parentElement;
      if (!parent) {
        var root = node.parentNode;
        if (root && root.host) {
          node = root.host;
          continue;
        }
        break;
      }
      Array.from(parent.children).forEach(function (sibling) {
        if (sibling === node) return;
        try {
          if (sibling.contains(dialog)) return;
        } catch (e) {}
        sibling.setAttribute('inert', '');
        inerted.push(sibling);
      });
      node = parent;
    }
  }

  function queryAllPopups() {
    var list = [];
    var light = document.querySelectorAll(POPUP_SELECTOR);
    Array.prototype.forEach.call(light, function (p) {
      list.push(p);
    });
    collectStockistShadowRoots().forEach(function (root) {
      Array.prototype.forEach.call(root.querySelectorAll(POPUP_SELECTOR), function (p) {
        list.push(p);
      });
    });
    return list;
  }

  function getOpenLeafletPopup() {
    if (isVisiblePopup(currentPopup)) return currentPopup;
    if (lastShadowRoot && typeof lastShadowRoot.querySelector === 'function') {
      var shadowed = lastShadowRoot.querySelector(POPUP_SELECTOR);
      if (isVisiblePopup(shadowed)) {
        currentPopup = shadowed;
        return shadowed;
      }
    }
    var all = queryAllPopups();
    for (var i = 0; i < all.length; i++) {
      if (isVisiblePopup(all[i])) {
        currentPopup = all[i];
        lastShadowRoot = all[i].getRootNode && all[i].getRootNode();
        return all[i];
      }
    }
    if (currentPopup && !currentPopup.isConnected) currentPopup = null;
    return null;
  }

  function enhancePopup(popup) {
    if (!popup || observedPopups.has(popup)) return;
    observedPopups.add(popup);
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-modal', 'true');
    if (!popup.hasAttribute('tabindex')) popup.setAttribute('tabindex', '-1');
  }

  function focusPopup(popup) {
    var first = getFocusable(popup)[0] || popup;
    requestAnimationFrame(function () {
      if (first && typeof first.focus === 'function') {
        first.focus({ preventScroll: true });
      }
    });
  }

  function findLeafletMap(fromEl) {
    var container = fromEl && fromEl.closest && fromEl.closest('.leaflet-container');
    if (!container) return null;
    if (container._leaflet_map && typeof container._leaflet_map.closePopup === 'function') {
      return container._leaflet_map;
    }
    var key;
    for (key in container) {
      if (!Object.prototype.hasOwnProperty.call(container, key)) continue;
      var val = container[key];
      if (val && typeof val.closePopup === 'function' && typeof val.getContainer === 'function') {
        return val;
      }
    }
    return null;
  }

  function closePopup(popup) {
    if (!popup) return;
    var root = popup.getRootNode && popup.getRootNode();
    var closeBtn =
      popup.querySelector(
        '.leaflet-popup-close-button, a.leaflet-popup-close-button, button.leaflet-popup-close-button, a[href="#close"], button.gm-ui-hover-effect, .gm-ui-hover-effect'
      ) ||
      popup.querySelector('[aria-label*="Close"], [title*="Close"], [aria-label*="close"], [title*="close"]') ||
      (root &&
        root.querySelector &&
        root.querySelector(
          '.leaflet-popup-close-button, a[href="#close"], button.gm-ui-hover-effect, .gm-ui-hover-effect'
        ));

    // Google InfoWindow close often sits as a sibling of .gm-style-iw-c
    if (!closeBtn && popup.parentElement) {
      closeBtn = popup.parentElement.querySelector('button.gm-ui-hover-effect, .gm-ui-hover-effect');
    }

    if (closeBtn) {
      try {
        closeBtn.dispatchEvent(
          new MouseEvent('click', { bubbles: true, cancelable: true, composed: true, view: window })
        );
      } catch (e) {}
      if (typeof closeBtn.click === 'function') closeBtn.click();
    }

    var map = findLeafletMap(popup);
    if (map) {
      try {
        map.closePopup();
      } catch (e2) {}
    }

    // Fallback if Stockist/Leaflet ignored the close control
    if (popup.isConnected) {
      var pane = popup.closest('.leaflet-popup-pane, .gm-style-iw-a, .gm-style');
      popup.style.display = 'none';
      popup.setAttribute('aria-hidden', 'true');
      try {
        popup.remove();
      } catch (e3) {}
      if (pane) {
        Array.prototype.forEach.call(pane.querySelectorAll(POPUP_SELECTOR), function (p) {
          try {
            p.remove();
          } catch (e4) {}
        });
      }
    }
  }

  function observePopupRoot(popup) {
    if (shadowObserver) {
      shadowObserver.disconnect();
      shadowObserver = null;
    }
    var root = popup && popup.getRootNode && popup.getRootNode();
    if (!root || root === document || root === document.documentElement) return;
    shadowObserver = new MutationObserver(function () {
      syncLeafletPopupA11y();
    });
    shadowObserver.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }

  function startWatchingPopup() {
    if (watchTimer) return;
    watchTimer = setInterval(function () {
      if (!getOpenLeafletPopup()) {
        clearBackgroundInert();
        currentPopup = null;
        clearInterval(watchTimer);
        watchTimer = null;
        if (shadowObserver) {
          shadowObserver.disconnect();
          shadowObserver = null;
        }
      }
    }, 300);
  }

  function syncLeafletPopupA11y() {
    var popup = getOpenLeafletPopup();
    if (!popup) {
      clearBackgroundInert();
      return;
    }

    enhancePopup(popup);
    setBackgroundInert(popup);
    observePopupRoot(popup);
    startWatchingPopup();

    var active = getActiveElement(popup);
    if (!popup.contains(active)) {
      focusPopup(popup);
    }
  }

  function rememberPopupFromEvent(event) {
    var path = typeof event.composedPath === 'function' ? event.composedPath() : [];
    for (var i = 0; i < path.length; i++) {
      var n = path[i];
      if (!n || typeof n.getRootNode !== 'function') continue;
      var root = n.getRootNode();
      if (root && root.host) {
        lastShadowRoot = root;
        break;
      }
    }
    var popup = findPopupInPath(event) || getOpenLeafletPopup();
    if (popup) {
      currentPopup = popup;
      syncLeafletPopupA11y();
      return true;
    }
    return false;
  }

  function watchStockistHosts() {
    document.querySelectorAll('stockist-store-locator').forEach(function (host) {
      if (host.__esLeafletObserved) return;
      host.__esLeafletObserved = true;
      var mo = new MutationObserver(function () {
        // When open shadow is available, observe it too.
        if (host.shadowRoot && !host.__esShadowObserved) {
          host.__esShadowObserved = true;
          mo.observe(host.shadowRoot, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
          lastShadowRoot = host.shadowRoot;
        }
        syncLeafletPopupA11y();
      });
      mo.observe(host, { childList: true, subtree: true, attributes: true });
      if (host.shadowRoot) {
        host.__esShadowObserved = true;
        mo.observe(host.shadowRoot, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
        lastShadowRoot = host.shadowRoot;
      }
      hostObservers.push(mo);
    });
  }

  function getFocusedMapControl() {
    var roots = collectStockistShadowRoots();
    var actives = [];
    var i;
    for (i = 0; i < roots.length; i++) {
      if (roots[i].activeElement) actives.push(roots[i].activeElement);
    }
    if (document.activeElement) actives.push(document.activeElement);

    for (i = 0; i < actives.length; i++) {
      var el = actives[i];
      if (!el || el.nodeType !== 1) continue;
      if (el.classList && el.classList.contains('leaflet-marker-icon')) return el;
      if (el.matches && el.matches('.stockist-list-result, .stockist-result, [data-stockist-id]')) return el;
      var marker = el.closest && el.closest('.leaflet-marker-icon, .stockist-list-result, .stockist-result, [data-stockist-id]');
      if (marker) return marker;
    }
    return null;
  }

  function activateMapControl(control) {
    if (!control) return false;
    lastTrigger = control;
    try {
      control.dispatchEvent(
        new MouseEvent('click', { bubbles: true, cancelable: true, composed: true, view: window })
      );
    } catch (e) {}
    if (typeof control.click === 'function') control.click();
    watchStockistHosts();
    setTimeout(syncLeafletPopupA11y, 50);
    setTimeout(syncLeafletPopupA11y, 200);
    setTimeout(syncLeafletPopupA11y, 500);
    return true;
  }

  function enhanceMarkersForKeyboard(root) {
    var scope = root || document;
    var markers = scope.querySelectorAll
      ? scope.querySelectorAll('.leaflet-marker-icon')
      : [];
    Array.prototype.forEach.call(markers, function (marker) {
      if (marker.getAttribute('tabindex') === null) marker.setAttribute('tabindex', '0');
      if (!marker.getAttribute('role')) marker.setAttribute('role', 'button');
      if (!marker.getAttribute('aria-label') && !marker.getAttribute('title')) {
        marker.setAttribute('aria-label', 'View store on map');
      }
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      if (rememberPopupFromEvent(event)) return;
      var path = typeof event.composedPath === 'function' ? event.composedPath() : [];
      var trigger = null;
      for (var i = 0; i < path.length; i++) {
        var n = path[i];
        if (!n || n.nodeType !== 1) continue;
        if (n.classList && n.classList.contains('leaflet-marker-icon')) {
          trigger = n;
          break;
        }
        if (n.matches && n.matches('a, button, [role="button"], .stockist-list-result, .stockist-result, [data-stockist-id]')) {
          trigger = n;
          break;
        }
      }
      if (trigger) lastTrigger = trigger;
      var host = event.target && event.target.closest && event.target.closest('stockist-store-locator');
      if (trigger || host) {
        watchStockistHosts();
        setTimeout(syncLeafletPopupA11y, 50);
        setTimeout(syncLeafletPopupA11y, 200);
        setTimeout(syncLeafletPopupA11y, 500);
      }
    },
    true
  );

  document.addEventListener(
    'focusin',
    function (event) {
      rememberPopupFromEvent(event);
      var path = typeof event.composedPath === 'function' ? event.composedPath() : [];
      for (var i = 0; i < path.length; i++) {
        var n = path[i];
        if (!n || typeof n.getRootNode !== 'function') continue;
        var root = n.getRootNode();
        if (root && root.host) {
          enhanceMarkersForKeyboard(root);
          break;
        }
      }
      collectStockistShadowRoots().forEach(enhanceMarkersForKeyboard);
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      var isActivate = event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar' || event.keyCode === 13 || event.keyCode === 32;
      var popup = getOpenLeafletPopup();

      // Enter/Space on a focused pin or store result opens the map popup.
      if (isActivate) {
        var inOpenPopup = popup && popup.contains(getActiveElement(popup));
        if (!inOpenPopup) {
          var control = getFocusedMapControl();
          // Ignore native links/buttons — they already activate on Enter.
          if (control && !(control.matches && control.matches('a[href], button, input, select, textarea'))) {
            event.preventDefault();
            event.stopPropagation();
            activateMapControl(control);
            return;
          }
          if (control && control.classList && control.classList.contains('leaflet-marker-icon')) {
            event.preventDefault();
            event.stopPropagation();
            activateMapControl(control);
            return;
          }
        }
      }

      if (!popup) return;

      if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) {
        event.preventDefault();
        event.stopPropagation();
        closePopup(popup);
        clearBackgroundInert();
        currentPopup = null;
        setTimeout(function () {
          syncLeafletPopupA11y();
          if (lastTrigger && typeof lastTrigger.focus === 'function') {
            lastTrigger.focus({ preventScroll: true });
          }
        }, 50);
        return;
      }

      if (event.key !== 'Tab') return;
      var focusable = getFocusable(popup);
      if (!focusable.length) {
        event.preventDefault();
        popup.focus({ preventScroll: true });
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      var active = getActiveElement(popup);
      if (event.shiftKey) {
        if (active === first || !popup.contains(active)) {
          event.preventDefault();
          last.focus({ preventScroll: true });
        }
      } else if (active === last || !popup.contains(active)) {
        event.preventDefault();
        first.focus({ preventScroll: true });
      }
    },
    true
  );

  // Some embeds only surface Escape on keyup inside the shadow tree.
  document.addEventListener(
    'keyup',
    function (event) {
      if (!(event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27)) return;
      var popup = getOpenLeafletPopup();
      if (!popup) return;
      event.preventDefault();
      event.stopPropagation();
      closePopup(popup);
      clearBackgroundInert();
      currentPopup = null;
    },
    true
  );

  var observer = new MutationObserver(function () {
    watchStockistHosts();
    collectStockistShadowRoots().forEach(enhanceMarkersForKeyboard);
    syncLeafletPopupA11y();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style']
  });

  watchStockistHosts();
  window.addEventListener('load', function () {
    watchStockistHosts();
    collectStockistShadowRoots().forEach(enhanceMarkersForKeyboard);
    syncLeafletPopupA11y();
  });
})();

(function initElieCountrySelector() {
  function syncCountryLabels(countryIso) {
    if (!countryIso) return;
    var selector =
      '.customCountryOption input[name="country_code1"][value="' +
      countryIso +
      '"], .customCountryOption input[name="country_code1"][value="' +
      countryIso.toUpperCase() +
      '"], .customCountryOption input[name="country_code1"][value="' +
      countryIso.toLowerCase() +
      '"]';
    var matched = false;

    document.querySelectorAll(selector).forEach(function (radio) {
      radio.checked = true;
      var label = radio.closest('.country-inline')?.querySelector('.labelwrapper');
      if (!label) return;
      matched = true;
      var html = label.innerHTML.trim();
      document.querySelectorAll('.inner-class.custom-selected').forEach(function (el) {
        el.innerHTML = html;
      });
      var dataCountry = radio.getAttribute('data-country');
      if (dataCountry) localStorage.setItem('selectedCountrynumber', dataCountry);
    });

    return matched;
  }

  function resolveLocalizationForm(sourceEl) {
    if (sourceEl) {
      var scopedForm = sourceEl.closest('localization-form')?.querySelector('form');
      if (scopedForm) return scopedForm;
    }
    return (
      document.querySelector('.customCountryOption')?.closest('localization-form')?.querySelector('form') ||
      document.querySelector('.default_country form')
    );
  }

  function setCountryCodeOnForm(form, countryIso) {
    if (!form || !countryIso) return false;

    var countryInput = form.querySelector('[data-elie-country-code-input], [name="country_code"]');
    if (countryInput) {
      if (countryInput.tagName === 'SELECT') {
        countryInput.value = countryIso;
        if (countryInput.value !== countryIso) {
          var option = countryInput.querySelector('option[value="' + countryIso + '"]');
          if (option) option.selected = true;
        }
      } else {
        countryInput.value = countryIso;
      }
      return countryInput.value === countryIso || countryInput.tagName === 'SELECT';
    }

    countryInput = document.createElement('input');
    countryInput.type = 'hidden';
    countryInput.name = 'country_code';
    countryInput.value = countryIso;
    countryInput.setAttribute('data-elie-country-code-input', '');
    form.appendChild(countryInput);
    return true;
  }

  window.applyElieCountrySelection = function applyElieCountrySelection(countryIso, sourceEl) {
    if (!countryIso) return false;

    countryIso = countryIso.toString().toUpperCase();
    localStorage.setItem('selectedCountry23', countryIso);
    localStorage.setItem('selectedCountry', countryIso);
    localStorage.setItem('ELIE_COUNTRY_ISO', countryIso);
    syncCountryLabels(countryIso);

    var form = resolveLocalizationForm(sourceEl);
    if (!form || !setCountryCodeOnForm(form, countryIso)) {
      var fallbackSelect = document.querySelector('.default_country select[name="country_code"]');
      var fallbackForm = fallbackSelect?.closest('form');
      if (fallbackForm && fallbackSelect) {
        fallbackSelect.value = countryIso;
        if (fallbackSelect.value !== countryIso) {
          var fallbackOption = fallbackSelect.querySelector('option[value="' + countryIso + '"]');
          if (fallbackOption) fallbackOption.selected = true;
        }
        form = fallbackForm;
      }
    }

    if (!form) return false;

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
    return true;
  };

  document.addEventListener('change', function (event) {
    var radio = event.target;
    if (!radio.matches || !radio.matches('.customCountryOption input[name="country_code1"]')) return;
    window.applyElieCountrySelection(radio.value, radio);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var radio = event.target;
    if (!radio.matches || !radio.matches('.customCountryOption input[name="country_code1"]')) return;
    event.preventDefault();
    radio.checked = true;
    window.applyElieCountrySelection(radio.value, radio);
  });
})();
